'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttonTextSubmit = require('common/components/button-text-submit');

var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('br', {});

var HomePageManualSignup = _react2['default'].createClass({
    displayName: 'HomePageManualSignup',


    propTypes: {
        'redirectUrl': _react2['default'].PropTypes.string,
        'initialErrorMessage': _react2['default'].PropTypes.string,
        'initialValue': _react2['default'].PropTypes.string,
        'utmCampaign': _react2['default'].PropTypes.string,
        'utmMedium': _react2['default'].PropTypes.string,
        'utmSource': _react2['default'].PropTypes.string,
        'utmTerm': _react2['default'].PropTypes.string,
        'campaignCode': _react2['default'].PropTypes.string,
        'onOptInChange': _react2['default'].PropTypes.func,
        'tabOffset': _react2['default'].PropTypes.number,
        'targetUrl': _react2['default'].PropTypes.string,
        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
    },

    render: function render() {

        var targetUrl = this.props.targetUrl || "/account/signUp";
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);

        var formData = {
            "signup[redirect_url]": this.props.redirectUrl,
            "signup[pending_tsm_group_guid]": this.props.pendingTsmGroupGuid, // for if the user sends a TsmGroup after they've gotten logged out somehow
            "signup[utm_campaign]": this.props.utmCampaign,
            "signup[utm_medium]": this.props.utmMedium,
            "signup[utm_source]": this.props.utmSource,
            "signup[utm_term]": this.props.utmTerm,
            "signup[campaign_code]": this.props.campaignCode,
            "signup[coupon_code]": "",
            "signup[billing_plan_quota_short_guid]": "",
            "signup[billing_period]": "",
            "signup[first_name]": "",
            "signup[last_name]": "",
            "signup[is_from_external]": "",
            "should_show_password": "0"
        };

        var validate = function validate(val) {
            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
                return "The email address that you've entered is invalid. Please try again.";
            } else {
                return false;
            }
        };

        var actionBtn = _jsx(_button2['default'], {
            buttonText: 'SIGN UP FREE',
            buttonClass: 'm-login-or-signup--sign-up-button',
            buttonColor: 'cerulean',
            buttonTabIndex: tabOffset + 1
        });

        // FIXME: too hardcoded to signup[] for my taste
        // FIXME: There's lot of things that could be refactored in here to make better use of BaseForm
        return _jsx(_buttonTextSubmit2['default'], {
            formName: 'newaccount',
            textPlaceholder: 'Email',
            textClass: 'm-login-or-signup--text-field',
            inputName: 'signup[email_address]',
            additionalFormData: formData,
            validate: validate,
            divClass: 'm-sign-mobile--send',
            url: targetUrl,
            initialValue: this.props.initialValue,
            actionButton: actionBtn,
            initialErrorMessage: this.props.initialErrorMessage,
            errorClass: 'c-warm-chinchilla',
            tabOffset: tabOffset,
            namespace: this.props.signupForm.namespace,
            fields: this.props.signupForm.fields,
            values: this.props.signupForm.values
        }, void 0, _ref, _jsx('input', {
            id: 'homepage_opt_in',
            type: 'checkbox',
            name: 'signup[is_opted_in_marketing_emails]',
            value: '1',
            defaultChecked: true,
            onChange: this.props.onOptInChange,
            tabIndex: tabOffset + 2
        }), _jsx('label', {
            htmlFor: 'homepage_opt_in',
            className: 'm-login-or-signup--opt-in-label'
        }, void 0, 'Send me HelloSign updates'));
    }

    //FIXME: "Send me HelloSign updates" should be a constant since it is used elsewhere
});

module.exports = HomePageManualSignup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/manual-signup.jsx
 ** module id = 764
 ** module chunks = 0
 **/